import {
  TextField,
  IconButton,
  InputAdornment,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Email, Clear } from "@material-ui/icons";
import DaumPostcode from "react-daum-postcode";
import Dialog from "../../dialog/functional/Dialog";
import DialogContent from "../../dialog/functional/DialogContent";
import DialogHeaderWithClose from "../../dialog/functional/DialogHeaderWithClose";
import DialogTitle from "../../dialog/functional/DialogTitle";

const themeObj = {
  searchBgColor: "#0B65C8",
  queryTextColor: "#FFFFFF",
};

function FormItemZipCode(props) {

  const { t } = useTranslation();
  const {
    column,
    InputLabelProps,
    value,
    onChange,
    onAddressSelectCallback,
    ...others
  } = props;

  const [zipcode, setZipcode] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setZipcode(value);
  }, [value]);

  const handleComplete = (data) => {
    const zonecode = data.zonecode;
    setZipcode(zonecode);
    setIsOpen(false);
    
    if (onAddressSelectCallback) {

      switch(data.userSelectedType) {

        case "R":
          data.address = data.roadAddress;
          data.englishAddress = data.roadAddressEnglish;
          onAddressSelectCallback(data);
        break;
        default :
          data.address = data.jibunAddress;
          data.englishAddress = data.jibunAddressEnglish;
          onAddressSelectCallback(data);
        break;
      }

    }
  };

  const handleClick = () => {
    setIsOpen(true);
  };

  const handleClear = () => {
    setZipcode("");
    if (onAddressSelectCallback) {
      onAddressSelectCallback({});
    }
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const mergedInputLabelProps = {
    shrink: true,
    ...InputLabelProps,
    ...(column.InputLabelProps || {}),
  };

  const inputPropsWithButton = {
    readOnly: true,
    style: {
      pointerEvents: "auto",
    },
    endAdornment: (
      <InputAdornment position="end">
        {zipcode && (
          <IconButton
            size="small"
            onClick={handleClear}
            style={props.disabled ? { pointerEvents: "none" } : {}}
          >
            <Clear fontSize="small" />
          </IconButton>
        )}
        <IconButton
          onClick={handleClick}
          style={props.disabled ? { pointerEvents: "none" } : {}}
        >
          <Email />
        </IconButton>
      </InputAdornment>
    ),
  };

  const InnerInputProps = {
    readOnly: true,
    style: {
      cursor: "default",
      userSelect: "none",
    },
    ...(column.inputProps || {}),
  };

  const baseFieldProps = {
    variant: column.variant,
    required: !!column.required,
    InputLabelProps: mergedInputLabelProps,
    inputProps: InnerInputProps,
    placeholder: column.placeholder
      ? t(column.placeholder)
      : t("placeholder.clickToSelectAddress"),
    value: zipcode,
    InputProps: inputPropsWithButton,
    ...others,
  };

  return (
    <>
      <TextField {...baseFieldProps} />
      <Dialog open={isOpen} onClose={handleClose} moveable fullWidth maxWidth="xs">
        <DialogHeaderWithClose>
          <DialogTitle>
          {t("dialog.title.search.zipcode")}
          </DialogTitle>
          </DialogHeaderWithClose>
        <DialogContent dividers style={{ padding: 0, height: 500}}>
          <DaumPostcode onComplete={handleComplete} theme={themeObj} style={{ width: "100%", height: "100%" }}/>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default FormItemZipCode;
